import { render, staticRenderFns } from "./dialog-note-list.vue?vue&type=template&id=3d73220c"
import script from "./dialog-note-list.vue?vue&type=script&lang=js"
export * from "./dialog-note-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d73220c')) {
      api.createRecord('3d73220c', component.options)
    } else {
      api.reload('3d73220c', component.options)
    }
    module.hot.accept("./dialog-note-list.vue?vue&type=template&id=3d73220c", function () {
      api.rerender('3d73220c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/contact/dialog-note-list.vue"
export default component.exports